import React from 'react';
import PropTypes from 'prop-types';

class Checkbox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedCheckboxes: [],
    };

    this.update = this.update.bind(this);
  }

  update(e) {
    let selected = this.state.selectedCheckboxes;
    let index;

    if (e.target.checked) {
      selected.push(e.target.value);
      if (e.target.value === 'unknown') {
        selected = ['unknown'];
      } else {
        const unknowIndex = selected.indexOf('unknown');
        if (unknowIndex > -1) {
          selected.splice(unknowIndex, 1);
        }
      }
    } else {
      index = selected.indexOf(e.target.value);
      selected.splice(index, 1);
    }

    this.setState({ selectedCheckboxes: selected.slice() });
  }

  render() {
    const { data } = this.props;

    return (
      <div className="input-checkbox-group">
        {data.options.length === 0 ? <option value="">Loading...</option> : null}
        {data.options.map(opt => (
          <div className={['input-checkbox', this.props.classes && this.props.classes].join(' ')} key={opt.id + this.props.name}>
            <input
              type="checkbox"
              id={this.props.name + (data.editable ? opt.value : opt.key)}
              value={data.editable ? opt.id : opt.key}
              onChange={this.update}
              name={this.props.name}
              checked={this.state.selectedCheckboxes.indexOf(opt.key) > -1}
              key={this.props.name + opt.id}
            />
            <label key={opt.id + this.props.name + opt.id} htmlFor={this.props.name + (data.editable ? opt.value : opt.key)}>{opt.value}</label>
          </div>
        ))}
      </div>
    );
  }
}

Checkbox.defaultProps = {
  name: '',
  classes: '',
};

Checkbox.propTypes = {
  name: PropTypes.string,
  classes: PropTypes.string,
  data: PropTypes.object.isRequired,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/Components/Inputs/Checkbox.jsx